import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function ViewTemplates (){
  const {user} = useUser()
  let view = contentLayout[modules.TemplatesList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.TemplatesList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.TemplatesList}></Index>
 )
}

export default ViewTemplates
